import React from "react";
import { Container } from "react-bootstrap";
import { StoreSection } from "../../../../redux/services/store/storeCategoryPagesApi";

type Props = {
  section: StoreSection;
};

const TextBlockSection: React.FC<Props> = ({ section }) => {
  const settings = section.settings_json || {};
  const items = section.items || [];
  const firstItem = items[0]?.content_json || {};

  const title = settings.title || firstItem.title || section.title || "";
  const text =
    settings.text ||
    firstItem.text ||
    firstItem.description ||
    "";

  if (!title && !text) return null;

  return (
    <section className="section">
      <Container fluid>
        <div className={settings.wrapper_class || "text-center"}>
          {title ? (
            <h2 className={settings.title_class || "mb-3"}>{title}</h2>
          ) : null}

          {text ? (
            <div
              className={settings.text_class || "text-muted"}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          ) : null}
        </div>
      </Container>
    </section>
  );
};

export default TextBlockSection;